import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("contaha_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("contaha_token");
    }
    if (err.response?.status === 402) {
      window.location.replace("https://contaha.com/pricing");
    }
    const d = err.response?.data?.detail;
    if (err.response?.status === 403 && d?.code === "consultations_exhausted") {
      toast.error(d.message, { id: "consult-exhausted", duration: 12000, action: { label: "Add consultations", onClick: () => { window.location.href = "/billing"; } } });
      err.response.data.detail = d.message;
    }
    return Promise.reject(err);
  }
);

export default api;
